const Footer = () => {
    return(
        <footer>
            <p>Created by</p>
            <ul className="teamAwesome">
                <li>
                    <p>
                        <a href="https://github.com/HibaAbdoulrezzak" aria-label="github"><i className="fab fa-github-alt" aria-hidden="true"></i> </a>
                        <a href="https://www.linkedin.com/in/abhiba/" aria-label="linkedin"><i className="fab fa-linkedin" aria-hidden="true"></i> </a>
                        Hiba Abdoulrezzak
                    </p>
                </li>
                <li>
                    <p>
                        <a href="https://github.com/MarkHarropGitHub" aria-label="github"><i className="fab fa-github-alt" aria-hidden="true"></i> </a>
                        <a href="https://www.linkedin.com/in/mark-harrop-7b76bb176/" aria-label="linkedin"><i className="fab fa-linkedin" aria-hidden="true"></i> </a>
                        Mark Harrop
                    </p>
                </li>
                <li>
                    <p>
                        <a href="https://github.com/JaeWanBae" aria-label="github"><i className="fab fa-github-alt" aria-hidden="true"></i> </a>
                        <a href="https://www.linkedin.com/in/jae-wan-peter-bae-48aa83207/" aria-label="linkedin"><i className="fab fa-linkedin" aria-hidden="true"></i> </a>
                        Peter Jae Wan Bae
                    </p>
                </li>
                <li>
                    <p>
                        <a href="https://github.com/iSupercell" aria-label="github"><i className="fab fa-github-alt" aria-hidden="true"></i> </a>
                        <a href="www.linkedin.com/in/si-jia-m-52710560" aria-label="linkedin"><i className="fab fa-linkedin" aria-hidden="true"></i> </a>
                        Si-Jia Mao
                    </p>
                </li>
            </ul>
            <p>at <a href="https://junocollege.com/">Juno College of Technology</a></p>
        </footer>
    );
};

export default Footer;